import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    continue: 'Save',
    headline: 'We need your SIRET number',
    hint: 'The 14 digit legal registration number for your business.\nYou can find it on your business registration document, or on your previous invoices.',
    placeholder: '828 701 557 00039',
  },
  fr: {
    continue: 'Enregistrer',
    headline: 'Ajouter votre numéro SIRET',
    hint: 'Le numéro d’immatriculation de votre entreprise à 14 chiffres.\nVous pouvez le trouver sur votre document d’immatriculation, ou sur vos anciennes factures.',
    placeholder: '828 701 557 00039',
  },
});

export default locales;
